export const PRICING_PAGE_URL =
  import.meta.env.VITE_APP_PRICING_PAGE_URL || "/angebote-finanzmanager";
